const {
  GET_ALL_FACTURE_REQUEST,
  GET_ALL_FACTURE_SUCCESS,
  GET_ALL_FACTURE_FAIL,
  ADD_FACTURE_REQUEST,
  ADD_FACTURE_SUCCESS,
  ADD_FACTURE_FAIL,
  GET_FACTURE_REQUEST,
  GET_FACTURE_SUCCESS,
  GET_FACTURE_FAIL,
  UPDATE_FACTURE_REQUEST,
  UPDATE_FACTURE_SUCCESS,
  UPDATE_FACTURE_FAIL,
  DELETE_FACTURE_REQUEST,
  DELETE_FACTURE_SUCCESS,
  DELETE_FACTURE_FAIL,

  ADD_FATCARTICLE_REQUEST,
  ADD_FATCARTICLE_SUCCESS,
  ADD_FATCARTICLE_FAIL,
  GET_FATCARTICLE_REQUEST,
  GET_FATCARTICLE_SUCCESS,
  GET_FATCARTICLE_FAIL,
  UPDATE_FATCARTICLE_REQUEST,
  UPDATE_FATCARTICLE_SUCCESS,
  UPDATE_FATCARTICLE_FAIL,
  DELETE_FATCARTICLE_REQUEST,
  DELETE_FATCARTICLE_SUCCESS,
  DELETE_FATCARTICLE_FAIL
} = require("../../actionTypes/Achat/Facture");

function getAllFactures(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_FACTURE_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_FACTURE_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_FACTURE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function getFacture(state = { data: {} }, action) {
  switch (action.type) {
    case GET_FACTURE_REQUEST:
      return { loading: true, data: {} };
    case GET_FACTURE_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_FACTURE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addFacture(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_FACTURE_REQUEST:
      return { loading: true, data: {} };
    case ADD_FACTURE_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_FACTURE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateFacture(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_FACTURE_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_FACTURE_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_FACTURE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteFacture(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_FACTURE_REQUEST:
      return { loading: true, data: {} };
    case DELETE_FACTURE_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_FACTURE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addArticleFact(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_FATCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case ADD_FATCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_FATCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function getArticleFact(state = { data: {} }, action) {
  switch (action.type) {
    case GET_FATCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case GET_FATCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_FATCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateArticleFact(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_FATCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_FATCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_FATCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteArticleFact(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_FATCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case DELETE_FATCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_FATCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export {
  addFacture,
  getFacture,
  updateFacture,
  deleteFacture,
  getAllFactures,
  addArticleFact,
  getArticleFact,
  updateArticleFact,
  deleteArticleFact
};
